/**
 * 메인: 카테고리 목록
 *
 *
 */
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { strCut, stringToMoneyFormat } from 'utils';
import { Content, Title, ProductItem, Row, Col, Button } from 'components';
import { Button as AntButton } from 'antd';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import Roasters from 'assets/roasters.png';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 이벤트목록 컴포넌트
 * ----------------------------------------
 */
const EventList = ({ screenSize }) => {
  /* ===== INIT ===== */
  const navigate = useNavigate();
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  // JSX: start
  return (
    <div
      style={{
        background: `url("/jm-coffee-roasters-main-02_1920x675.jpg")center center / cover no-repeat`,
      }}
      className="regulatdelivery"
    >
      <Content
        maxWidth={'100%'}
        backgroundColor="rgba(0,0,0,0.6)"
        padding={screenSize >= 500 ? '150px 15px' : '60px 0'}
        style={{
          margin: '0 auto',
          textAlign: 'center',
        }}
      >
        <Title
          align="center"
          color="#fff"
          className="dela-gothic"
          style={{
            fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
            lineHeight: '150%',
          }}
        >
          Regular Delivery
        </Title>
        <br />
        <br />
        <Title
          color="#fff"
          align="center"
          style={{ fontSize: screenSize >= 500 ? 30 : 18 }}
        >
          제이엠커피그룹 제품 정기배송
        </Title>
        <br />
        <Title
          color="#fff"
          align="center"
          style={{ fontSize: screenSize >= 500 ? 18 : 14 }}
        >
          집에서도 편리하게, 언제나 신선하게!
          <br />
          원하는 날짜에 맞춰 제이엠커피를 정기적으로 받아보세요.
        </Title>
        <br />
        <br />
        <Button
          onClick={() => navigate(`/products?type=subscription`)}
          className={'goto'}
          style={{ marginTop: screenSize >= 500 ? 50 : 20 }}
        >
          바로가기 <RightOutlined />
        </Button>
      </Content>
    </div>
  ); // JSX: end
};

export default EventList;
